import { DisplayXSmall, ParagraphMedium } from 'baseui/typography'
import { useTranslation } from 'react-i18next'

function ValidationEmailSent() {
  const { t } = useTranslation()
  return (
    <div>
      <DisplayXSmall as="h1">{t('SIGN_OK')}</DisplayXSmall>
      <ParagraphMedium>{t('SEND_EMAIL_VALIDATE')}</ParagraphMedium>
    </div>
  )
}

export default ValidationEmailSent
